import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

function About() {
  return (
    <div className="about">
      <Header />

      <div className="container">
        <img src="/assets/images/sub/sub01.jpg" alt="" className="mainImg" />
        <div className="innerTop">
          <div className="subTitle">
            <h2>회사소개</h2>
            <h1>
              일상을 환하게,
              <br />
              공간을 특별하게
            </h1>
          </div>
          <div className="menuNav">
            <FontAwesomeIcon icon={faHouse} className="faHouse" />
            <span>/</span>
            <h2>회사소개</h2>
            <span>/</span>
            <h2>회사소개</h2>
          </div>
        </div>
      </div>
      <div className="menuBar aboutMenuBar">
        <Link to="/about" className="aboutMenu">
          <h2>회사소개</h2>
        </Link>
        <Link to="/history" className="historyMenu">
          <h2>연혁</h2>
        </Link>
        <Link to="/contact" className="contactMenu">
          <h2>찾아오시는 길</h2>
        </Link>
      </div>

      <div className="contentInner">
        <h1>밤을 밝히다, 아름다움을 더하다</h1>
        <h2>
          빛이 닿는 곳마다 새로운 이야기가 시작됩니다. 한국미광의 LED 경관조명은
          자연의 모든 순간을 더욱 빛나게 하고, 주위 환경과 완벽하게 어우러져
          공간을 예술로 완성합니다. 이제 당신의 공간에 특별한 이야기를 더하세요
        </h2>
        <img src="/assets/images/sub/about.jpg" alt="" className="companyImg" />
        <p className="aboutText">
          (주)한국미광은 2018년 10월 설립 후, 구조물 및 특화된 옥외 공간에 야간
          도시경관을 연출을 진행하는 회사입니다. 여러 지자체 등 관공서 계약을
          통하여 이 분야에서 좋은 평가를 이뤄내고 있습니다.
          <br />
          <br />
          저희 한국미광은 우리 모두가 살아가는 터전의 공간인 만큼 내가 생활할
          곳처럼이라는 마음가짐으로 좋은 서비스를 보여드리기 위하여 노력
          중입니다.
          <br />
          <br />
          조명 제조 전문 업체로써 조달청 나라장터 종합 쇼핑몰에 등록되어 있으며
          매년 신제품 업데이트로 우수한 판매 실적을 보유하고 있습니다.
          <br />
          체계적인 디자인 설계, 고품질 제품 생산, 철저한 사후 서비스를 포함한
          여러 분야의 우수한 자격을 갖춘 인재들과 함께 나아갑니다.
          <br />
          <br />
          저희 한국미광은 더욱더 발전된 모습으로 다수의 만족을 실현하고 나아가
          아름다운 빛의 대한민국을 만들기위해 항상 노력하겠습니다.
        </p>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default About;
